import { render, staticRenderFns } from "./SnackBarComponent.vue?vue&type=template&id=6f864883&scoped=true"
import script from "./SnackBarComponent.vue?vue&type=script&lang=js"
export * from "./SnackBarComponent.vue?vue&type=script&lang=js"
import style0 from "./SnackBarComponent.vue?vue&type=style&index=0&id=6f864883&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f864883",
  null
  
)

export default component.exports